import { render, staticRenderFns } from "./ZyroSeparator.vue?vue&type=template&id=422360ba&scoped=true&"
var script = {}
import style0 from "./ZyroSeparator.vue?vue&type=style&index=0&id=422360ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422360ba",
  null
  
)

export default component.exports